export const REDUCER_NAME = "enquirySlice";

export interface iEnquiryDTO {
  product_id?: string;
  product_title?: string;
  quantity?: number;
  price?: string;
  name?: string;
  email?: string;
  message?: string;
}

export interface iEnquiryResponse {
  id: string;
  vendor_id: string;
  product_id: string;
  product_title: string;
  quantity: number;
  price: string;
  name: string;
  email: string;
  message: string;
  created_at: string;
  updated_at: string;
}

export interface iEnquiryState {
  isLoading: boolean;
  enquiryList: iEnquiryResponse[];
  errorMessage: string | null;
}